export default function capitalizeStringUtil (str) {
  str = str || ''
  if (!str.length) {
    return str
  }
  return str[0].toUpperCase() + str.slice(1)
}
